'use strict';

class CRadioButtonController{
  constructor(){

  }
  $onInit(){
   
  }
}
export default CRadioButtonController;



// WEBPACK FOOTER //
// ./src/app/common/core/util/c-components-bootstrap/c-radiobutton/c-radiobutton.controller.js